import React from "react";
import GitHubIcon from "@mui/icons-material/GitHub";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import "../assets/styles/Main.scss";
import pfp from "../assets/images/pfp.jpeg";
import { SiLeetcode } from "react-icons/si";
import { SiGeeksforgeeks } from "react-icons/si";
import { Analytics } from "@vercel/analytics/react";
function Main() {
  return (
    <div className="container">
      <div className="about-section">
        <div className="image-wrapper">
          <img src={pfp} alt="avatar" />
        </div>
        <div className="content">
          <div className="social_icons">
            <a
              href="https://github.com/abhishek9111"
              target="_blank"
              rel="noreferrer"
            >
              <GitHubIcon />
            </a>
            <a
              href="https://www.linkedin.com/in/abhishek9111/"
              target="_blank"
              rel="noreferrer"
            >
              <LinkedInIcon />
            </a>
            <a
              href="https://leetcode.com/u/kapoorabhishek567/"
              target="_blank"
              rel="noreferrer"
            >
              <SiLeetcode />
            </a>
            <a
              href="https://www.geeksforgeeks.org/user/kapoorabhishek567"
              target="_blank"
              rel="noreferrer"
            >
              <SiGeeksforgeeks />
            </a>
          </div>
          <h1>Abhishek kapoor</h1>
          <p className="social_icons">
            IoT hobbyist | Full Stack Engineer | Cyber security enthusiast
          </p>
          <p className="mobile_social_icons">
            IoT hobbyist <br />
            Full Stack Engineer
            <br />
            Cyber security enthusiast
          </p>

          <div className="mobile_social_icons">
            <a
              href="https://github.com/abhishek9111"
              target="_blank"
              rel="noreferrer"
            >
              <GitHubIcon />
            </a>
            <a
              href="https://www.linkedin.com/in/abhishek9111/"
              target="_blank"
              rel="noreferrer"
            >
              <LinkedInIcon />
            </a>
            <a
              href="https://leetcode.com/u/kapoorabhishek567/"
              target="_blank"
              rel="noreferrer"
            >
              <SiLeetcode />
            </a>
            <a
              href="https://www.geeksforgeeks.org/user/kapoorabhishek567"
              target="_blank"
              rel="noreferrer"
            >
              <SiGeeksforgeeks />
            </a>
          </div>
        </div>
      </div>
      <Analytics />
    </div>
  );
}

export default Main;
